import React, { useEffect, useState } from 'react';

// @ts-ignore
const TimedAlert = ({ text, type = 'success', show, onClose, duration = 5000 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timeout: any;
    if (show) {
      setVisible(true);
      timeout = setTimeout(() => {
        setVisible(false);
        onClose?.();
      }, duration);
    }
    return () => clearTimeout(timeout);
  }, [show, duration, onClose]);

  if (!visible) return null;

  return (
    <div
      className={`alert alert-${type} alert-dismissible fade show`}
      role="alert"
      style={{ position: 'fixed', top: '20px', right: '20px', minWidth: '250px', zIndex: 9999 }}
    >
      {text}
      <button
        type="button"
        className="btn-close"
        onClick={() => {
          setVisible(false);
          onClose?.();
        }}
        aria-label="Закрыть"
      ></button>
    </div>
  );
};

export default TimedAlert;
